export const removeKeys = (obj: any, ...keysToRemove: any[]) => {
    const newObj = { ...obj };

    keysToRemove.forEach((key) => {
        delete newObj[key];
    });

    return newObj;
};
